var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"page404"},[_c('div',{staticClass:"e404"}),_c('div',{staticClass:"error-tips"},[_c('p',[_vm._v(_vm._s(_vm.$t('页面访问错误_请稍后访问___')))]),_c('a',{staticClass:"blueLink f14",attrs:{"href":_vm.overviewLink}},[_vm._v(_vm._s(_vm.$t('前往概览页__')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }